import { render, staticRenderFns } from "./NewMember.vue?vue&type=template&id=bd1e6ed8&scoped=true&"
import script from "./NewMember.vue?vue&type=script&lang=js&"
export * from "./NewMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1e6ed8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
